import { addDoc, collection, deleteDoc, doc, getDoc, getDocs, updateDoc } from "firebase/firestore";
import { db } from "../firebaseConfig";
import { FireStoreProduct, Product } from "../model/ProducModel";

export const ProductGateway = {

  GetProducts: async (status: string | null, categoryId: string | null): Promise<FireStoreProduct[]> => {
    try {
      const productsRef = collection(db, "products");
      const productsSnapshot = await getDocs(productsRef);

      const products: FireStoreProduct[] = productsSnapshot.docs
        .filter(doc => !status || doc.data().status === status)
        .filter(doc => !categoryId || doc.data().category === categoryId)
        .map(doc => ({
          product: doc.data() as Product, // Type assertion
          id: doc.id,
        }));

      return products;
    } catch (error) {
      console.error("Error fetching products:", error);
      return [];
    }
  },

  GetProduct: async (productId: string) => {
    const ref = doc(db, "products", productId);
    var docSnap = await getDoc(ref);

    if (docSnap.exists()) {
      return docSnap.data() as Product;
    }

    return null;
  },
  AddProduct: async (product: Product) => {
    const docRef = await addDoc(collection(db, 'products'), { ...product });
    return docRef.id;
  },
  UpdateProduct: async (productId: string, product: Product) => {
    return updateDoc(doc(db, 'products', productId), { ...product });
  },
  DeleteProduct: async (productId: string) => {
    return deleteDoc(doc(db, 'products', productId));
  },

  GetKey: (productId: string, attributes: { [key: string]: string }) => {

    if (!attributes)
      return productId;

    const sortedAttributes = Object.entries(attributes)
      .sort(([keyA], [keyB]) => keyA.localeCompare(keyB))
      .map(([key, value]) => `${key}:${value}`)
      .join("|");

    return `${productId}#${sortedAttributes}`;
  },
  GetAttributePrice(
    product: Product,
    name: string,
    value: string
  ): number {
    if (!product.attributes) return 0;

    const match = product.attributes.find(
      (attr) => attr.name === name && attr.value === value
    );

    return match ? Number(match.price) : 0;
  }

};